export default __webpack_public_path__ + "static/media/us-flag.735fd77f.png";